<template>
  <el-upload
    v-if="uploadtype=='fileurl'"
    uploadfile
    single
    ref="upload"
    :action="uploadUrl"
    :accept="accept"
    :auto-upload="false"
    :file-list="filelist"
    :on-exceed="onExceed"
    :on-change="handleChange"
    :on-remove="handleRemove"
  >
    <el-button size="small" type="primary">{{btntext}}</el-button>
    <div slot="tip" v-if="showtips" class="el-upload__tip" v-text="getTips()"></div>
  </el-upload>
  <el-upload
    v-else-if="uploadtype=='filelist'"
    :file-list="filelist"
    drag
    uploadfile
    multiple
    :limit="Number(maxlength)"
    :action="uploadUrl"
    :on-exceed="onExceed"
    :on-change="handleChange"
    :on-remove="handleRemove"
  >
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    <div slot="tip" v-if="showtips" class="el-upload__tip" v-text="getTips()"></div>
  </el-upload>
</template>
<script>
  import Vue from "vue";
  import $ from "jquery";
  import hUrl from "@/utils/url";
  const OSS = require('ali-oss');
  export default {
    name: 'MyInputFile',
    model: {
      prop: 'inputval',
    },
    props: {
      maxlength: {
        type: [String, Number],
        default: 999999999
      },
      inputval: {},
      showtips: {
        type: [Boolean],
        default: true
      },
      btntext: {
        type: [String],
        default: '点击上传'
      },
      tips: {
        type: [String],
        default: ''
      },
      acceptfiles: {
        type: [String],
        default: 'jpg;jpeg'
      },
      acceptsize: {
        type: [String],
        default: '2M'
      },
      uploadtype: {
        type: [String],
        default(){
          return 'img';
        }
      },
      showlist: {
        type: [Boolean],
        default: false
      },
      uploadsingle: {
        type: [Boolean],
        default: true
      },
      autoupload: {
        type: [Boolean],
        default: true
      }
    },
    data(){
      return $.extend(true, {}, this.getDefData(), {
        percent: 0,
        uploading: false,
        showbeginbtn: false,
        imgurl: '',
        imglist: [],
        fileurl: '',
        filelist: [],
        fileurllist: [],
        readyfiles: [],
        uploadlen: 0,
        toshowlist: this.showlist,
        data: this.uploadapply,
        imgmaxsize: 500 * 1000,//500kb
      }, this.getFromParent())
    },
    watch: {
      inputval(a, b, c){
        var parent = this.getFromParent();
        //用extend时不能带true，否则会出现无法重新渲染的，原因可能是陷入死循环
        $.extend(this, parent);
      }
    },
    computed: {
      // 计算属性的 getter
      rawhttp: function () {
        // `this` 指向 vm 实例
        return this.useoss || this.usealimedia ? 'http-request' : '';
      },
      accept: function () {
        var arr = this.acceptfiles.split(';');
        var strarr = [];
        for (var i = 0; i < arr.length; i++) {
          var obj = arr[i];
          if (obj.indexOf('*') > -1) {
            strarr.push(obj);
          } else {
            strarr.push('.' + obj);
          }
        }
        return strarr.join(',');
      }
    },
    methods: {
      getFromParent(){
        var data = {};
        if (this.uploadtype == 'fileurl') {
          data.fileurl = this.inputval;
          if(!this.inputval){
            data.filelist=[];
          }
        }
        if (this.uploadtype == 'filelist') {
          var inputarr = this.inputval || [];
          data.filelist = $.extend(true, [], inputarr);
        }
        return data;
      },
      syncToParent(){
        var data;
        if (this.uploadtype == 'fileurl') {
          data = this.getFieldVal(this.filelist, '0.raw', null);
        } else if (this.uploadtype == 'filelist') {
          data = $.pluck(this.filelist, 'raw');
        }
        this.$emit('input', data);
        this.$emit('uploadready', data);
      },
      handleRemove(file, fileList)
      {
        this.filelist.splice(this.filelist.indexOf(file), 1);
        this.uploadlen--;
        this.syncToParent();
      },
      handleBeforeUpload(rawfile){
        if ((this.uploadtype == 'img' || this.uploadtype == 'imglist')
          && rawfile.size > this.imgmaxsize) {
          this.error('{1}大于500kb'.format(rawfile.name));
          return false;
        }
      },
      handleChange(file, fileList){
        if (this.handleBeforeUpload(file) != false) {
          fileList.splice(0, fileList.length - 1);
          this.filelist = fileList;
          this.syncToParent();
        } else {
          fileList.splice(fileList.indexOf(file), 1);
        }
      },
      onExceed(files, fileList){
        this.warning('不能超过{1}个'.format(this.maxlength));
      },
      getTips(){
        if (this.tips) {
          return this.tips;
        } else {
          if (this.uploadtype == 'fileurl') {
            return '只能上传{1}文件{2}'.format(this.acceptfiles, '，且不超过{1}'.hformat(this.acceptsize));
          } else if (this.uploadtype == 'filelist') {
            return '只能上传{1}文件{2}'.format(this.acceptfiles, '，且不超过{1}'.hformat(this.acceptsize));
          }
        }
      }
    }

  }
</script>
<style>
  [uploadimgcard] {
    min-height: 150px;
    position: relative;
  }

  [uploadimgcard] .el-upload-list.el-upload-list--picture-card {
  }

  [uploadimgcard] .el-upload.el-upload--picture-card {
    position: absolute;
    top: 0;
    left: 0;
  }

  /*屏蔽批量上传图片时预览状态*/
  ul.el-upload-list--picture
  li.el-upload-list__item.is-success.el-list-leave.el-list-leave-active, ul.el-upload-list--picture li.el-upload-list__item.is-uploading.el-list-move.el-list-leave.el-list-leave-active, ul.el-upload-list--picture li.el-upload-list__item.is-success.el-list-enter.el-list-enter-active, ul.el-upload-list--picture li.el-upload-list__item.is-uploading.el-list-leave.el-list-leave-active, ul.el-upload-list--picture li.el-upload-list__item.is-success.el-list-leave-active.el-list-move.el-list-leave-to, ul.el-upload-list--picture li.el-upload-list__item.is-uploading.el-list-leave-active.el-list-leave-to, ul.el-upload-list--picture li.el-upload-list__item.is-ready {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyInputFile.vue